import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Proposal: A formal request for funding or approval, typically submitted to a governing body or organization for consideration.',
    name: 'Proposals',
    partialId: PartialId.Standard.create('proposals'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
